var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "flex items-center justify-between px-5 py-4 bg-gray-100 border-b"
    },
    [
      _c(
        "div",
        { staticClass: "flex items-center" },
        [
          _c("AssigneeDropdown", {
            attrs: { assignee: _vm.conversation.assignedTo },
            on: { onItemClicked: _vm.updateAssignee }
          }),
          _c("StatusDropdown", {
            attrs: { status: _vm.conversation.status },
            on: { onItemClicked: _vm.updateStatus }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }